import type { PsHttpSSE } from '@patsnap-utils/sse';
import type { GetClaimCompareMatchParams, ClaimCompareMatchData, GetResultPositionParams, ResultPositionData, GetClaimCompareTranslationParams, ClaimCompareTranslationData, GetClaimCompareExportParams, SetClaimCompareTranslationCacheParams, ClaimFeatureData, CompareFeatureData, FeatureCompareState, GetComparePatentData } from '../types';
import type { StreamStatus } from '../types/enum';
import type { ApiGetClaimCompareResultResponse } from '@/infrastructure/api-functions/core-search-api/get-claim-compare-result-api';
import type { ApiGetClaimFeatureResponse } from '@/infrastructure/api-functions/core-search-api/get-claim-feature-api';

export const GetClaimFeatureRepository = Symbol.for('GetClaimFeatureRepository');

export interface GetClaimFeatureRepository {
    getClaimFeatures(patentId: string, callback: (status: StreamStatus, content?: ClaimFeatureData) => void, errorCallback?: (error: { error_code?: number }) => void): PsHttpSSE<ApiGetClaimFeatureResponse>;
    getClaimFeaturesFromText(text: string, callback: (status: StreamStatus, content?: ClaimFeatureData) => void, errorCallback?: (error: { error_code?: number }) => void): PsHttpSSE<ApiGetClaimFeatureResponse>;
}


export const GetClaimCompareMatchRepository = Symbol.for('GetClaimCompareMatchRepository');

export interface GetClaimCompareMatchRepository {
    getClaimCompareMatch(data: GetClaimCompareMatchParams): Promise<ClaimCompareMatchData>
}

export const GetResultPositionRepository = Symbol.for('GetResultPositionRepository');

export interface GetResultPositionRepository {
    getResultPosition(data: GetResultPositionParams): Promise<ResultPositionData>
}

export const GetClaimCompareTranslationRepository = Symbol.for('GetClaimCompareTranslationRepository');

export interface GetClaimCompareTranslationRepository {
    getClaimCompareTranslation(data: GetClaimCompareTranslationParams): Promise<ClaimCompareTranslationData>
}

export const GetClaimCompareExportRepository = Symbol.for('GetClaimCompareExportRepository');

export interface GetClaimCompareExportRepository {
    getClaimCompareExport(data: GetClaimCompareExportParams): Promise<string>
}

export const SetClaimCompareTranslationCacheRepository = Symbol.for('SetClaimCompareTranslationCacheRepository');
export interface SetClaimCompareTranslationCacheRepository {
    setClaimCompareTranslationCache(data: SetClaimCompareTranslationCacheParams): Promise<ClaimCompareTranslationData>
}

export const GetClaimCompareResultRepository = Symbol.for('GetClaimCompareResultRepository');
export interface GetClaimCompareResultRepository {
    getClaimCompareResult(data: FeatureCompareState, callback: (streamStatus: StreamStatus, content?: Partial<CompareFeatureData>) => void, errorCallback?: (error: { error_code?: number }) => void): PsHttpSSE<ApiGetClaimCompareResultResponse>;
}

export const GetComparePatentRepository = Symbol.for('GetComparePatentRepository');
export interface GetComparePatentRepository {
    getComparePatent(q: string): Promise<GetComparePatentData>
}
